// Mirrors EnumAccessTier in services/taxonomy.
export const ACCESS_TIER_OPTIONS = [
    { label: "public", value: "public" },
    { label: "private", value: "private" },
    { label: "thirdParty", value: "thirdParty" },
    { label: "internal", value: "internal" },
];

export const DEFAULT_ACCESS_TIER = "internal";

const ORDER = ACCESS_TIER_OPTIONS.map((option) => option.value);

// Mirrors resolveTier in services/taxonomy: the stricter of the group's and the parameter's own tier.
export function effectiveTier(groupTier?: string | null, ownTier?: string | null) {
    const tiers = [groupTier, ownTier].filter((tier) => ORDER.includes(tier));
    if (!tiers.length) return DEFAULT_ACCESS_TIER;
    return tiers.reduce((strictest, tier) => (ORDER.indexOf(tier) > ORDER.indexOf(strictest) ? tier : strictest));
}
